import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {LogisticRoutePageComponent} from "./view/logistic-route-page/logistic-route-page.component";

const logisticRoutes: Routes = [
  {
    path: '',
    component: LogisticRoutePageComponent
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(logisticRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class LogisticRoutesRoutingModule {
}

